import {
  Button,
  Card,
  Inline,
  Separator,
  Stack,
  Text,
} from "@generalapplications/ui";

import { routes } from "@/app/common/functions/routes/routes";

/** The invitation that ends an article. */
export function ArticleContactCta() {
  return (
    <Stack gap="xl">
      <Separator />
      <Card padding="md">
        <Inline collapseBelow="sm" justify="between" gap="md">
          <Stack gap="xs">
            <Text weight="bold">Have thoughts on this post?</Text>
            <Text variant="secondary">
              We welcome discussions and feedback on our architectural
              observations.
            </Text>
          </Stack>
          <Button href={routes.contact} size="lg">
            Start a Conversation
          </Button>
        </Inline>
      </Card>
    </Stack>
  );
}
